module.exports = __webpack_public_path__ + "img/2_12.5c3af796.jpg";